import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onImageLoad", "minImageHeight", "minImageWidth", "tooltipReduced", "tooltipStandard", "children", "onClick", "description", "descriptionStandard", "descriptionReduced"];
import { useCallback, useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import ThumbnailModal from './ThumbnailModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ThumbnailUploader = _ref => {
  let {
      onImageLoad,
      minImageHeight,
      minImageWidth,
      tooltipReduced,
      tooltipStandard,
      children,
      onClick,
      description,
      descriptionStandard,
      descriptionReduced
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [displayModal, setDisplayModal] = useState(false);
  const handleOnClick = useCallback(e => {
    setDisplayModal(true);
    if (onClick) onClick(e);
  }, [onClick]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [displayModal && /*#__PURE__*/_jsx(ThumbnailModal, {
      description: description,
      descriptionReduced: descriptionReduced,
      descriptionStandard: descriptionStandard,
      minImageHeight: minImageHeight,
      minImageWidth: minImageWidth,
      onClose: () => setDisplayModal(false),
      onImageLoad: onImageLoad,
      tooltipReduced: tooltipReduced,
      tooltipStandard: tooltipStandard
    }), /*#__PURE__*/_jsx(UIButton, Object.assign({
      onClick: handleOnClick
    }, buttonProps, {
      children: children
    }))]
  });
};